// This import loads the firebase namespace along with all its type information.
import PurchasedItem from './purchased-item-model'

export async function load_purchasedItems(): Promise<PurchasedItem[]> {
  throw 'Not implemented'
}

export async function delete_purchasedItem(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_purchasedItem(): Promise<PurchasedItem> {
  throw 'Not implemented'
}
